export interface PopHistoryStackEntryAction<A extends string = string> {
  type: A;
}

export const createPopHistoryStackEntryActionCreator = <A extends string>(
  actionTypePrefix: string,
): (() => PopHistoryStackEntryAction<A>) => (): PopHistoryStackEntryAction<
  A
> => ({
  type: (actionTypePrefix + 'POP') as A,
});
